import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import Media from 'react-media'
import Spinner from "../../../../components/_common/Spinner";


const NRTButton = (props) => {

    const {
        onClick,
        children,
        content,
        tabIndex,
        className,
        loading
    } = props


    const iconButtonCls = props.iconButton ? ' icon-button ' : ' '
    const dangerCls = props.danger ? ' danger ' : ' '
    const outlineCls = props.outline ? ' outline ' : ' '
    const secondaryCls = props.secondary ? ' secondary ' : ' '
    const actionButtonCls = props.actionButton ? ' action-button ' : ' '
    const smallCls = props.small ? ' small ' : ' '
    const noBorderCls = props.noBorder ? ' no-border ' : ' '
    const disabledCls = props.disabled ? ' disabled ' : ' '

    return (
        <a
            className={"NrtButton " + className + smallCls + noBorderCls +
            outlineCls + secondaryCls + actionButtonCls + dangerCls + iconButtonCls + disabledCls}
            onClick={(evt) => {
                if (!!evt)
                    evt.preventDefault()

                if (props.disabled)
                    return

                onClick()
            }}
            style={{...props.style}}
            tabIndex={tabIndex}
            title={props.title || content}
            href={'#'}
        >
            {loading ? <Media query="(max-width: 425px)">
                {matches => matches ?
                    <Spinner width={18}/> : <Spinner width={25}/>}
            </Media> : children || content}
        </a>
    )
}


NRTButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
    outline: PropTypes.bool,
    secondary: PropTypes.bool,
    content: PropTypes.any,
    actionButton: PropTypes.bool,
    danger: PropTypes.bool,
    small: PropTypes.bool,
    iconButton: PropTypes.bool,
    noBorder: PropTypes.bool,
    disabled: PropTypes.bool,
    title: PropTypes.string,
    loading: PropTypes.bool
}


NRTButton.defaultProps = {
    className: ' ',
    style: {},
    small: false,
    outline: false,
    secondary: false,
    actionButton: false,
    danger: false,
    iconButton: false,
    noBorder: false,
    disabled: false,
    loading: false
}


export default NRTButton




// WEBPACK FOOTER //
// ./src/components/_common/_buttons/Button/index.js